<template>
                <div v-if="currentView === 'security_filter'">
                    <div class="page-header"><div><div class="page-title">過濾與稽核</div><div class="page-subtitle">Rspamd 垃圾信過濾與 ClamAV 病毒掃描</div></div></div>

                    <!-- Rspamd Status -->
                    <div class="card p-6 mb-6">
                        <div class="flex justify-between items-center mb-4">
                            <h3 class="font-bold" style="color:var(--gray-700);">垃圾信過濾 (Rspamd)</h3>
                            <a href="http://localhost:11334/" target="_blank"
                                class="btn btn-primary btn-sm text-sm">開啟 Rspamd
                                控制台</a>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                            <div class="card p-4">
                                <div class="text-sm" style="color:var(--gray-500);">服務狀態</div>
                                <div class="font-bold text-lg"
                                    :style="{ color: serviceStatus.rspamd === 'running' ? 'var(--color-success)' : 'var(--color-danger)' }">
                                    {{ serviceStatus.rspamd === 'running' ? '運作中' : '已停止' }}
                                </div>
                            </div>
                        </div>

                        <div class="card p-4 mb-4">
                            <div class="flex items-center justify-between mb-2">
                                <div class="font-bold text-sm" style="color:var(--gray-700);">Rspamd 統計</div>
                                <button @click="fetchRspamdStats" :disabled="rspamdStatsLoading"
                                    class="btn btn-dark btn-xs">
                                    {{ rspamdStatsLoading ? '載入中...' : '重新整理' }}
                                </button>
                            </div>
                            <div v-if="rspamdStats" class="grid grid-cols-1 md:grid-cols-4 gap-3">
                                <div class="card p-3">
                                    <div class="text-xs" style="color:var(--gray-500);">Scanned</div>
                                    <div class="text-lg font-bold" style="color:var(--gray-800);">{{ rspamdStats.scanned || 0 }}</div>
                                </div>
                                <div class="card p-3">
                                    <div class="text-xs" style="color:var(--gray-500);">Spam</div>
                                    <div class="text-lg font-bold" style="color:var(--color-danger);">{{ rspamdStats.spam || 0 }}</div>
                                </div>
                                <div class="card p-3">
                                    <div class="text-xs" style="color:var(--gray-500);">Ham</div>
                                    <div class="text-lg font-bold" style="color:var(--color-success);">{{ rspamdStats.ham || 0 }}</div>
                                </div>
                                <div class="card p-3">
                                    <div class="text-xs" style="color:var(--gray-500);">Learned</div>
                                    <div class="text-lg font-bold" style="color:var(--gray-800);">{{ rspamdStats.learned || 0 }}</div>
                                </div>
                            </div>
                            <div v-else class="text-sm" style="color:var(--gray-500);">尚無統計資料 (controller 可能尚未開啟)。</div>
                        </div>

                        <h4 class="font-bold text-sm mb-2">評分閾值設定 (Actions)</h4>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">拒絕 (Reject) 分數</label>
                                <input v-model.number="rspamdActions.reject" :disabled="!isSuperAdmin" type="number" step="0.1"
                                    class="input">
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">標記 (Add Header) 分數</label>
                                <input v-model.number="rspamdActions.add_header" :disabled="!isSuperAdmin" type="number" step="0.1"
                                    class="input">
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">灰名單 (Greylist) 分數</label>
                                <input v-model.number="rspamdActions.greylist" :disabled="!isSuperAdmin" type="number" step="0.1"
                                    class="input">
                            </div>
                        </div>
                        <div class="mt-4">
                            <button v-if="isSuperAdmin" @click="updateRspamdActions"
                                class="btn btn-primary">儲存設定</button>
                            <div v-else class="text-xs" style="color:var(--gray-500);">僅超級管理員可修改 Actions。</div>
                        </div>
                    </div>

                    <!-- ClamAV Status -->
                    <div class="card p-6 mb-6">
                        <h3 class="font-bold mb-4" style="color:var(--gray-700);">病毒掃描 (ClamAV)</h3>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div class="card p-4">
                                <div class="text-sm" style="color:var(--gray-500);">服務狀態</div>
                                <div class="font-bold text-lg"
                                    :style="{ color: serviceStatus.clamav === 'running' ? 'var(--color-success)' : 'var(--color-danger)' }">
                                    {{ serviceStatus.clamav === 'running' ? '運作中' : '已停止' }}
                                </div>
                            </div>
                        </div>
                        <p class="text-sm mt-2" style="color:var(--gray-500);">ClamAV 會自動更新病毒碼並掃描所有進出郵件的附件。</p>
                    </div>

                    <div class="card p-6 mb-6">
                        <div class="flex items-center justify-between mb-4 flex-wrap gap-2">
                            <h3 class="font-bold" style="color:var(--gray-700);">AI 防詐騙/垃圾信自動隔離</h3>
                            <div class="flex items-center gap-2">
                                <button @click="fetchAiSettings"
                                    class="btn btn-dark btn-xs">
                                    重新載入
                                </button>
                                <button @click="saveSecurityAutoSettings"
                                    class="btn btn-success btn-xs">
                                    儲存設定
                                </button>
                            </div>
                        </div>
                        <div class="text-sm mb-4" style="color:var(--gray-500);">
                            啟用後會以伺服器端自動掃描郵件並移動到隔離資料夾。需在 admin_api 環境變數設定 MAIL_AUTOMATION_PASSWORD 才會生效。
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="space-y-4">
                                <div>
                                    <label class="block text-sm font-bold mb-2" style="color:var(--gray-700);">啟用自動掃描</label>
                                    <label class="inline-flex items-center cursor-pointer">
                                        <input type="checkbox" v-model="aiSettingsForm.security_auto_enabled" class="sr-only peer">
                                        <div
                                            class="relative w-11 h-6 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:border after:rounded-full after:h-5 after:w-5 after:transition-all" style="background:var(--gray-200);" :style="aiSettingsForm.security_auto_enabled ? 'background:var(--primary);' : ''">
                                        </div>
                                        <span class="ms-3 text-sm font-medium" style="color:var(--gray-900);">{{ aiSettingsForm.security_auto_enabled ? '已啟用' : '未啟用' }}</span>
                                    </label>
                                </div>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label class="block text-sm font-bold mb-2" style="color:var(--gray-700);">掃描週期（秒）</label>
                                        <input v-model.number="aiSettingsForm.security_auto_interval_seconds" type="number" min="10" max="3600"
                                            class="input" />
                                    </div>
                                    <div>
                                        <label class="block text-sm font-bold mb-2" style="color:var(--gray-700);">每次掃描筆數</label>
                                        <input v-model.number="aiSettingsForm.security_auto_limit" type="number" min="1" max="500"
                                            class="input" />
                                    </div>
                                </div>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
                                    <div>
                                        <label class="block text-sm font-bold mb-2" style="color:var(--gray-700);">掃描資料夾</label>
                                        <input v-model.trim="aiSettingsForm.security_auto_folder" type="text"
                                            class="input" placeholder="INBOX" />
                                    </div>
                                    <div class="pb-1">
                                        <label class="inline-flex items-center cursor-pointer select-none">
                                            <input type="checkbox" v-model="aiSettingsForm.security_auto_unseen_only" class="mr-2" />
                                            <span class="text-sm font-bold" style="color:var(--gray-700);">只掃未讀</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="space-y-4">
                                <div class="card p-4">
                                    <div class="flex items-center justify-between mb-3">
                                        <div class="font-bold" style="color:var(--gray-800);">AI 詐騙隔離</div>
                                        <label class="inline-flex items-center cursor-pointer select-none">
                                            <input type="checkbox" v-model="aiSettingsForm.security_auto_phishing_enabled" class="mr-2" />
                                            <span class="text-sm font-bold" style="color:var(--gray-700);">{{ aiSettingsForm.security_auto_phishing_enabled ? '啟用' : '停用' }}</span>
                                        </label>
                                    </div>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label class="block text-sm font-bold mb-2" style="color:var(--gray-700);">門檻（0-1）</label>
                                            <input v-model.number="aiSettingsForm.security_auto_phishing_threshold" type="number" min="0" max="1" step="0.05"
                                                class="input" />
                                        </div>
                                        <div>
                                            <label class="block text-sm font-bold mb-2" style="color:var(--gray-700);">目標資料夾</label>
                                            <input v-model.trim="aiSettingsForm.security_auto_phishing_target" type="text"
                                                class="input" placeholder="Phishing" />
                                        </div>
                                    </div>
                                </div>

                                <div class="card p-4">
                                    <div class="flex items-center justify-between mb-3">
                                        <div class="font-bold" style="color:var(--gray-800);">AI 垃圾信隔離</div>
                                        <label class="inline-flex items-center cursor-pointer select-none">
                                            <input type="checkbox" v-model="aiSettingsForm.security_auto_spam_enabled" class="mr-2" />
                                            <span class="text-sm font-bold" style="color:var(--gray-700);">{{ aiSettingsForm.security_auto_spam_enabled ? '啟用' : '停用' }}</span>
                                        </label>
                                    </div>
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label class="block text-sm font-bold mb-2" style="color:var(--gray-700);">門檻（分數）</label>
                                            <input v-model.number="aiSettingsForm.security_auto_spam_threshold" type="number" min="0" step="0.5"
                                                class="input" />
                                        </div>
                                        <div>
                                            <label class="block text-sm font-bold mb-2" style="color:var(--gray-700);">目標資料夾</label>
                                            <input v-model.trim="aiSettingsForm.security_auto_spam_target" type="text"
                                                class="input" placeholder="Spam" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card p-6 mb-6">
                        <div class="flex items-center justify-between mb-4">
                            <h3 class="font-bold" style="color:var(--gray-700);">郵件稽核摘要</h3>
                            <div class="flex items-end gap-2">
                                <div>
                                    <div class="text-[10px] mb-1" style="color:var(--gray-500);">天數</div>
                                    <select v-model.number="securityMailDays" class="input text-xs w-24">
                                        <option :value="7">7 日</option>
                                        <option :value="30">30 日</option>
                                        <option :value="90">90 日</option>
                                    </select>
                                </div>
                                <div>
                                    <div class="text-[10px] mb-1" style="color:var(--gray-500);">高垃圾分門檻</div>
                                    <input v-model.number="securityMailSpamThreshold" type="number" step="0.1"
                                        class="input text-xs w-28">
                                </div>
                                <button @click="refreshSecurityMailAudit" :disabled="securityMailSummaryLoading || securityMailTrendLoading"
                                    class="btn btn-dark btn-xs">
                                    {{ (securityMailSummaryLoading || securityMailTrendLoading) ? '載入中...' : '重新整理' }}
                                </button>
                            </div>
                        </div>
                        <div v-if="securityMailSummary" class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                            <div class="card p-4">
                                <div class="text-xs" style="color:var(--gray-500);">近 {{ securityMailSummary.days }} 日總量</div>
                                <div class="text-2xl font-bold" style="color:var(--gray-800);">{{ securityMailSummary.total || 0 }}</div>
                            </div>
                            <div class="card p-4">
                                <div class="text-xs" style="color:var(--gray-500);">高垃圾分 (≥ {{ securityMailSummary.spam_threshold }})</div>
                                <div class="text-2xl font-bold" style="color:var(--color-danger);">{{ securityMailSummary.high_spam_count || 0 }}</div>
                                <button @click="openSecurityHighSpamDetails" class="mt-2 text-xs hover:underline" style="color:var(--brand-600);">
                                    查看明細
                                </button>
                            </div>
                            <div class="card p-4">
                                <div class="text-xs" style="color:var(--gray-500);">平均垃圾分</div>
                                <div class="text-2xl font-bold" style="color:var(--color-warning);">{{ Number(securityMailSummary.avg_spam_score || 0).toFixed(2) }}</div>
                            </div>
                            <div class="card p-4">
                                <div class="text-xs" style="color:var(--gray-500);">狀態種類</div>
                                <div class="text-2xl font-bold" style="color:var(--gray-800);">{{ Object.keys(securityMailSummary.status_counts || {}).length }}</div>
                            </div>
                        </div>
                        <div v-if="securityMailSummary" class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="card p-4">
                                <div class="text-sm font-bold mb-2" style="color:var(--gray-700);">狀態統計</div>
                                <div class="text-sm space-y-1" style="color:var(--gray-700);">
                                    <div v-for="(v, k) in (securityMailSummary.status_counts || {})" :key="k"
                                        class="flex justify-between">
                                        <span class="font-mono">{{ k || '(空)' }}</span>
                                        <span class="font-bold">{{ v }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="card p-4">
                                <div class="text-sm font-bold mb-2" style="color:var(--gray-700);">寄件者 Top</div>
                                <div v-if="(securityMailSummary.top_senders || []).length === 0" class="text-sm" style="color:var(--gray-500);">尚無資料</div>
                                <div v-else class="text-sm space-y-1" style="color:var(--gray-700);">
                                    <div v-for="row in securityMailSummary.top_senders" :key="row.sender"
                                        class="flex justify-between">
                                        <span class="font-mono truncate pr-2">{{ row.sender }}</span>
                                        <span class="font-bold">{{ row.count }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-sm" style="color:var(--gray-500);">尚無稽核摘要資料。</div>

                        <div v-if="(securityMailTrend || []).length" class="mt-6">
                            <div class="text-sm font-bold mb-2" style="color:var(--gray-700);">趨勢 (每日)</div>
                            <div class="h-64 relative">
                                <canvas id="securityMailTrendChart"></canvas>
                            </div>
                        </div>
                    </div>

                    <div v-if="showSecurityHighSpamModal"
                        class="modal-overlay">
                        <div class="modal-box" style="max-width:min(1100px,95vw);width:100%;">
                            <div class="modal-header">
                                <div>
                                    <div class="text-lg font-bold" style="color:var(--gray-800);">高垃圾分明細</div>
                                    <div class="text-xs" style="color:var(--gray-500);">近 {{ (securityMailSummary && securityMailSummary.days) || (securityMailDays || 30) }} 日，分數 ≥ {{ (securityMailSummary && securityMailSummary.spam_threshold) || (securityMailSpamThreshold || 10) }}</div>
                                </div>
                                <button @click="closeSecurityHighSpamDetails" class="btn btn-secondary btn-sm">關閉</button>
                            </div>
                            <div class="modal-body" style="background:var(--gray-50);border-bottom:1px solid var(--border);">
                                <div class="flex flex-wrap gap-3 items-end">
                                    <div>
                                        <label class="block text-xs mb-1" style="color:var(--gray-600);">寄件者包含</label>
                                        <input v-model="securityHighSpamFilter.sender" class="input w-64" placeholder="example@domain.com">
                                    </div>
                                    <div>
                                        <label class="block text-xs mb-1" style="color:var(--gray-600);">狀態包含</label>
                                        <input v-model="securityHighSpamFilter.status" class="input w-48" placeholder="sent / bounced / rejected">
                                    </div>
                                    <button @click="fetchSecurityHighSpamDetails" :disabled="securityHighSpamLoading"
                                        class="btn btn-primary">
                                        {{ securityHighSpamLoading ? '載入中...' : '重新整理' }}
                                    </button>
                                </div>
                            </div>
                            <div class="modal-body">
                                <div v-if="securityHighSpamLoading" class="text-sm" style="color:var(--gray-500);">載入中...</div>
                                <div v-else class="overflow-x-auto">
                                    <table class="data-table">
                                        <thead>
                                            <tr>
                                                <th class="p-2 w-56">時間</th>
                                                <th class="p-2 w-72">寄件者</th>
                                                <th class="p-2 w-72">收件者</th>
                                                <th class="p-2 w-24">狀態</th>
                                                <th class="p-2 w-24">分數</th>
                                                <th class="p-2 w-24">操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="securityHighSpamLogs.length === 0">
                                                <td colspan="6" class="p-6 text-center" style="color:var(--gray-500);">無資料</td>
                                            </tr>
                                            <tr v-for="(row, idx) in safeArr(securityHighSpamLogs)" :key="keyById(row, 'spamlog', idx)">
                                                <td class="p-2 whitespace-nowrap">{{ new Date(row.timestamp).toLocaleString() }}</td>
                                                <td class="p-2 font-mono break-all">{{ row.sender }}</td>
                                                <td class="p-2 font-mono break-all">{{ row.recipient }}</td>
                                                <td class="p-2">
                                                    <span class="badge"
                                                        :class="row.status === 'sent' ? 'badge-success' : 'badge-warning'">
                                                        {{ row.status }}
                                                    </span>
                                                </td>
                                                <td class="p-2 font-bold" style="color:var(--color-danger);">
                                                    {{ Number(row.spam_score || 0).toFixed(2) }}
                                                </td>
                                                <td class="p-2">
                                                    <div class="flex items-center gap-2">
                                                        <button @click="openMailFromSecurityLog(row)" :disabled="securityHighSpamOpenLoadingId === row.id" class="btn btn-ghost btn-xs" style="color:var(--brand-600);">開啟郵件</button>
                                                        <button @click="copyToClipboard(row.sender)" class="btn btn-ghost btn-xs" style="color:var(--brand-500);">複製</button>
                                                        <button v-if="isSuperAdmin" @click="quickAllowSender(extractEmail(row.sender || ''))" :disabled="senderMapsLoading" class="btn btn-ghost btn-xs" style="color:var(--color-success);">允許</button>
                                                        <button v-if="isSuperAdmin" @click="quickBlockSender(extractEmail(row.sender || ''))" :disabled="senderMapsLoading" class="btn btn-ghost btn-xs" style="color:var(--color-danger);">封鎖</button>
                                                        <button v-if="isSuperAdmin" @click="quickAllowDomainFromText(row.sender || '')" :disabled="senderMapsLoading" class="btn btn-ghost btn-xs" style="color:var(--color-success);">允許網域</button>
                                                        <button v-if="isSuperAdmin" @click="quickBlockDomainFromText(row.sender || '')" :disabled="senderMapsLoading" class="btn btn-ghost btn-xs" style="color:var(--color-danger);">封鎖網域</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Greylist Whitelist -->
                    <div class="card p-6">
                        <h3 class="font-bold mb-4" style="color:var(--gray-700);">灰名單白名單 (Greylist Whitelist)</h3>
                        <p class="text-sm mb-2" style="color:var(--gray-500);">下列 IP 位址將略過灰名單檢查 (每行一個 IP 或 CIDR)。</p>
                        <textarea v-model="greylistWhitelistText" :disabled="!isSuperAdmin" rows="5"
                            class="input w-full font-mono mb-4" placeholder="127.0.0.1"></textarea>
                        <button v-if="isSuperAdmin" @click="updateGreylistWhitelist"
                            class="btn btn-primary">儲存白名單</button>
                        <div v-else class="text-xs" style="color:var(--gray-500);">僅超級管理員可修改 Greylist Whitelist。</div>
                    </div>

                    <!-- Sender Allow/Block -->
                    <div class="card p-6">
                        <div class="flex items-center justify-between mb-4">
                            <h3 class="font-bold" style="color:var(--gray-700);">寄件者白/黑名單 (Rspamd From Map)</h3>
                            <button v-if="isSuperAdmin" @click="restartRspamd"
                                class="btn btn-primary btn-sm text-sm">套用 (重啟 Rspamd)</button>
                        </div>
                        <p class="text-sm mb-4" style="color:var(--gray-500);">每行一筆：email (user@domain) 或網域 (domain.com / @domain.com)。</p>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <div class="font-semibold mb-2" style="color:var(--gray-700);">白名單</div>
                                <textarea v-model="senderAllowlistText" rows="6"
                                    :disabled="!isSuperAdmin"
                                    class="input w-full font-mono mb-3" placeholder="user@example.com&#10;@trusted.com"></textarea>
                                <button v-if="isSuperAdmin" @click="updateSenderAllowlist"
                                    class="btn btn-primary">儲存白名單</button>
                            </div>
                            <div>
                                <div class="font-semibold mb-2" style="color:var(--gray-700);">黑名單</div>
                                <textarea v-model="senderBlocklistText" rows="6"
                                    :disabled="!isSuperAdmin"
                                    class="input w-full font-mono mb-3" placeholder="spammer@example.com&#10;bad-domain.com"></textarea>
                                <button v-if="isSuperAdmin" @click="updateSenderBlocklist"
                                    class="btn btn-danger">儲存黑名單</button>
                            </div>
                        </div>
                        <div v-if="!isSuperAdmin" class="text-xs mt-3" style="color:var(--gray-500);">僅超級管理員可檢視 / 修改寄件者白黑名單。</div>
                    </div>

                    <!-- Rspamd Learn -->
                    <div class="card p-6">
                        <h3 class="font-bold mb-4" style="color:var(--gray-700);">回報垃圾信 (Rspamd)</h3>
                        <p class="text-sm mb-2" style="color:var(--gray-500);">貼上完整原始郵件 (EML，包含 header)。</p>
                        <textarea v-model="rspamdLearnEml" rows="7"
                            class="input w-full font-mono mb-3"
                            placeholder="Return-Path: &lt;...&gt;&#10;From: ...&#10;To: ...&#10;Subject: ...&#10;&#10;(body)"></textarea>
                        <div class="flex flex-wrap gap-3 items-center">
                            <button @click="learnRspamd('spam')" :disabled="rspamdLearnLoading"
                                class="btn btn-danger disabled:opacity-50">
                                {{ rspamdLearnLoading ? '回報中...' : '回報垃圾信' }}
                            </button>
                            <button @click="scanRspamdByEml()" :disabled="rspamdLearnLoading || rspamdScanLoading"
                                class="btn btn-primary disabled:opacity-50">
                                {{ rspamdScanLoading ? '掃描中...' : '掃描分數' }}
                            </button>
                            <button @click="loadRspamdEmlFromCurrentMessage()"
                                :disabled="rspamdLearnLoading || rspamdScanLoading || !currentMessage || !currentMessage.id"
                                class="btn btn-dark">
                                載入目前郵件 EML
                            </button>
                            <button @click="rspamdLearnEml=''; rspamdLearnEmlLoadedKey=''; rspamdLearnResult=null; rspamdLearnResultKey=''; rspamdScanResult=null; rspamdScanResultKey=''; rspamdLearnCache={}; rspamdScanCache={}" :disabled="rspamdLearnLoading"
                                class="btn btn-secondary">
                                清空
                            </button>
                        </div>
                        <pre v-if="rspamdLearnResult" class="mt-4 p-3 rounded text-xs overflow-auto" style="background:#0d1117;color:#e2e8f0;">{{ JSON.stringify(rspamdLearnResult, null, 2) }}</pre>
                        <div v-if="rspamdScanDetails" class="card p-3 mt-4 text-sm">
                            <div class="flex flex-wrap gap-x-6 gap-y-2">
                                <div><span style="color:var(--gray-500);">Action</span> <span class="font-semibold">{{ rspamdScanDetails.action || '-' }}</span></div>
                                <div><span style="color:var(--gray-500);">Score</span> <span class="font-semibold">{{ rspamdScanDetails.scoreDisplay }}</span></div>
                            </div>
                            <table v-if="rspamdScanDetails.symbols && rspamdScanDetails.symbols.length" class="w-full mt-3 text-xs">
                                <thead>
                                    <tr class="border-b" style="color:var(--gray-500);">
                                        <th class="py-1 text-left">Symbol</th>
                                        <th class="py-1 text-right">Score</th>
                                        <th class="py-1 text-left">Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="s in rspamdScanDetails.symbols" :key="s.name" class="border-b last:border-b-0">
                                        <td class="py-1 font-mono">{{ s.name }}</td>
                                        <td class="py-1 text-right">{{ s.score }}</td>
                                        <td class="py-1">{{ s.description || '' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <pre v-if="rspamdScanResult" class="mt-4 p-3 rounded text-xs overflow-auto" style="background:#0d1117;color:#e2e8f0;">{{ JSON.stringify(rspamdScanResult, null, 2) }}</pre>
                    </div>
                </div>


</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAppStore } from '../store/app.js'

const store = useAppStore()

// Spread all store state as reactive refs accessible in template
const stateRefs = storeToRefs(store)
// Destructure - Vue compiler exposes all variables declared in <script setup> to template
const {
  // Core state
  token, currentView, currentUser, loginForm, loginError,
  branding, notifications, showNotifPanel,
  // Command palette
  showCmdPalette, cmdQuery, cmdResults, cmdGrouped, cmdDefaults, cmdSelIdx,
  // Domain / Users / Departments
  domains, domainForm, showDomainForm, domainLoading,
  users, userForm, showUserForm, userLoading, userError,
  departments, deptForm, showDeptForm, deptLoading,
  // Contacts / Groups
  contacts, contactForm, showContactForm, contactLoading,
  groups, groupForm, showGroupForm, groupLoading,
  // Mail
  mailQueues, mailQueueLoading, mailQueueFilter,
  serviceStatus, serviceLoading,
  // Invoice Drive
  invoiceDriveState,
  // Quotes / Products
  quotes, quoteForm, showQuoteForm, quoteLoading,
  products, productForm, showProductForm, productLoading,
  priceBooks, priceBookForm, showPriceBookForm,
  // SSL
  sslCerts, sslLoading, sslDomain,
  // Security
  securityWizardStep, spamStats,
  securityFilterState,
  // Server settings
  serverMailSettings, serverDnsSettings, serverDbSettings, serverAiSettings,
  backupSettings,
  // Logs / Audit
  logs, logFilter, logLoading,
  mailAuditRecords, auditFilter, auditLoading,
  securityAuditLogs, securityAuditFilter,
  logAnalysisResult, logAnalysisLoading,
  // AI / RAG / Sales
  ragState, aiSalesState, aiMarketingState,
  // LINE
  lineSupportState,
  // Webmail
  webmailState, webmailAutoScanInvoices, webmailAutoScanMarkRead,
  // Unreplied
  unrepliedEmails, unrepliedLoading,
  // CBI
  cbiInsights, cbiLoading,
  // Misc
  sidebarCollapsed, sidebarMobile,
  journeyEnrollments, journeyEnrollmentsLoading,
  journeyFunnel, journeyFunnelLoading, journeyFunnelFilters,
  showJourneyEditorModal, showJourneyFunnelModal, showJourneyEnrollmentsModal,
  selectedJourneyForEnrollments, selectedJourneyForFunnel,
  journeyEditorForm,
  isSuperAdmin, rspamdStats, rspamdStatsLoading, rspamdActions, aiSettingsForm,
  // Security mail audit
  currentMessage,
  greylistWhitelistText, senderAllowlistText, senderBlocklistText, senderMapsLoading,
  rspamdLearnEml, rspamdLearnEmlLoadedKey, rspamdLearnLoading, rspamdLearnResult, rspamdLearnResultKey,
  rspamdScanLoading, rspamdScanResult, rspamdScanResultKey, rspamdLearnCache, rspamdScanCache,
  rspamdScanDetails,
  securityMailSummary, securityMailSummaryLoading, securityMailDays, securityMailSpamThreshold,
  securityMailTrend, securityMailTrendLoading, showSecurityHighSpamModal,
  securityHighSpamLogs, securityHighSpamLoading, securityHighSpamOpenLoadingId, securityHighSpamFilter,
} = stateRefs

// Methods are accessed directly from store (not reactive, no storeToRefs needed)
const {
  login, logout, switchSidebarView, canAccess,
  openCommandPalette, closeCmdPalette, updateCmdResults, execCmdItemById,
  moveCmdSel, toggleNotifPanel, markNotifRead, clearNotifs,
  fetchDomains, saveDomain, deleteDomain,
  fetchUsers, saveUser, deleteUser, resetUserPassword,
  fetchDepartments, saveDepartment, deleteDepartment,
  fetchContacts, saveContact, deleteContact, importContacts,
  fetchGroups, saveGroup, deleteGroup,
  fetchMailQueue, releaseMailQueueItem, deleteMailQueueItem, flushMailQueue,
  fetchServiceStatus, fetchSpamStats,
  fetchSslCerts, issueSslCert, deleteSslCert,
  fetchProducts, saveProduct, deleteProduct,
  fetchPriceBooks, savePriceBook, deletePriceBook,
  fetchQuotes, saveQuote, deleteQuote, sendQuote,
  fetchLogs, fetchLogAnalysis,
  fetchMailAuditRecords, fetchSecurityAuditLogs,
  fetchServerMailSettings, saveServerMailSettings,
  fetchServerDnsSettings, saveServerDnsSettings,
  fetchServerDbSettings, saveServerDbSettings,
  fetchServerAiSettings, saveServerAiSettings,
  fetchBackupSettings, saveBackupSettings, triggerBackup,
  fetchSecurityFilter, saveSecurityFilter,
  fetchRagDocuments, uploadRagDocument, deleteRagDocument, queryRag,
  fetchUnreplied,
  fetchCbiInsights,
  loadBrandingFromLocal, saveBranding,
  safeArr, keyById,
  invoiceDriveCanGotoAdjacent, invoiceDriveGotoAdjacent,
  openInvoiceDetail, closeInvoiceDetail,
  fetchRspamdStats, updateRspamdActions, fetchAiSettings, saveSecurityAutoSettings,
  quickAllowSender, quickBlockSender, quickAllowDomainFromText, quickBlockDomainFromText, extractEmail,
  refreshSecurityMailAudit, openSecurityHighSpamDetails, closeSecurityHighSpamDetails,
  fetchSecurityHighSpamDetails, openMailFromSecurityLog, copyToClipboard,
  updateGreylistWhitelist, restartRspamd, updateSenderAllowlist, updateSenderBlocklist,
  learnRspamd, scanRspamdByEml, loadRspamdEmlFromCurrentMessage,
} = store
</script>

